import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    return createStyles({
        root: {},
        stickyHeader: {},
        sticky: {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[2],
        },
        stickyLeft: {
            right: 0,
        },
        stickyRight: {
            left: 0,
        },
        paddingCheckbox: {
            padding: '0 4px 0 4px',
        },
    });
};

export default makeStyles(styles, { name: 'MuiTableCell' });
